<app-image-box [url]="logoPath$$()" [border]="false" />

@if (showForm$$()) {
    <form id="form" [formGroup]="Form" autocomplete="chrome-off" (keyup.enter)="login()">
        <h2>Voer login gegevens in.</h2>
        <app-input-control [htmlAutocomplete]="'off'"
            [autofocus]="true"
            [control]="FormControls.email"
            [label]="'email'"
            [lockOnLoad]="true"
            [placeholder]="'fill in email'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'email'" />
        <app-input-control
            [htmlAutocomplete]="'current-password'"
            [control]="FormControls.password"
            [label]="'password'"
            [lockOnLoad]="false"
            [placeholder]="'fill in password'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'password'" />
        <div>
            <p class="my-1">
                <a routerLink="/recover">Wachtwoord vergeten?</a>
            </p>
        </div>
        <div>
            <p class="my-1">
                <a routerLink="/register">Registreer als nieuwe gebruiker</a>
            </p>
        </div>
    </form>
} @else {
    <form id="form" [formGroup]="TwoFactorForm" autocomplete="off" (keyup.enter)="verifyTwoFactor()">
        <h2>Voer de code uit je authenticator-app in.</h2>
        <app-input-control [htmlAutocomplete]="'one-time-code'"
            [autofocus]="true"
            [control]="TwoFactorFormControls.code"
            [label]="'code'"
            [lockOnLoad]="true"
            [placeholder]="'6-cijferige code'"
            [showError]="showErrors || TwoFactorForm.touched"
            [tabIndex]="'0'"
            [type]="'text'" />
    </form>
}

<ng-template #template_sectionDetails_extraButtons>
    @if (showForm$$()) {
        <app-button-action form="form"
            (btnClick)="login()"
            [loadKey]="loadKeys"
            [lockOnLoad]="true"
        >login</app-button-action>
    } @else {
        <app-button-action form="form"
            (btnClick)="verifyTwoFactor()"
            [loadKey]="loadKeys"
            [lockOnLoad]="true"
        >bevestig</app-button-action>
    }
</ng-template>